import { type ListResults } from 'core/domain/Request'
import { type HttpClientConfig, type HttpClientInterface } from 'core/infra/http/HttpClient'

import { type RawRelatedLoadOffer, type Relation } from '../domain/RelatedLoad'

type RelatedLoadRepositoryDependencies = {
  httpClient: HttpClientInterface
}

type GetRelatedLoadOffersParams = {
  loadUUID: string
  relation?: Relation
  page?: number
  pageSize?: number
  config?: Partial<HttpClientConfig>
}

export class RelatedLoadRepository {
  private httpClient: HttpClientInterface

  constructor({ httpClient }: RelatedLoadRepositoryDependencies) {
    this.httpClient = httpClient
  }

  async getRelatedLoadOffers({
    loadUUID,
    relation,
    page = 1,
    pageSize = 15,
    config,
  }: GetRelatedLoadOffersParams): Promise<ListResults<RawRelatedLoadOffer>> {
    const endpoint = `/api/v2/loadboard/loads/${loadUUID}/related-offers`
    const params = {
      page,
      page_size: pageSize,
      ...(relation && { relation }),
    }

    const { data } = await this.httpClient.get<ListResults<RawRelatedLoadOffer>>(endpoint, {
      ...config,
      params,
    })

    return data
  }

  async getPublicRelatedLoadOffers({
    loadUUID,
    relation,
    page = 1,
    pageSize = 15,
    config,
  }: GetRelatedLoadOffersParams): Promise<ListResults<RawRelatedLoadOffer>> {
    const endpoint = `/api/v2/loadboard/public/loads/${loadUUID}/related-offers`
    const params = {
      page,
      page_size: pageSize,
      ...(relation && { relation }),
    }

    const { data } = await this.httpClient.get<ListResults<RawRelatedLoadOffer>>(endpoint, {
      ...config,
      params,
    })

    return data
  }
}
